import React from 'react';
import { Box, Tooltip } from '@mui/material';
import PermissionCheckbox from './PermissionCheckbox';
import { Permission } from '../../../types/permissionType';
import { EntityName } from '../Permissions.styles';

type EntityItem = {
  id: number | string;
  name: string;
};

type Props = {
  permissions: Permission[];
  entity: EntityItem;
  checkedMap: Record<string, boolean>;
  onCheckboxToggle: (perm: Permission, isPerEntity: boolean, entityId: number) => void;
  disabled: boolean;
};

const PerEntityPermissionList: React.FC<Props> = ({
  permissions,
  entity,
  checkedMap,
  onCheckboxToggle,
  disabled,
}) => {
  const entityId = Number(entity.id);

  return (
    <Box key={entity.id} sx={{ mb: 1 }}>
      <Tooltip title={entity.name}>
        <EntityName variant="subtitle1" tabIndex={0}>{entity.name}</EntityName>
      </Tooltip>
      <Box>
        {permissions.map((perm) => {
          const parentKey = `${perm.entityType}.${perm.permissionName}`;
          const childKey = `${perm.entityType}.${perm.permissionName}.${entity.id}`;
          const isParentChecked = checkedMap[parentKey] ?? false;
          const effectiveChecked = checkedMap[childKey] || isParentChecked || false;

          return (
            <PermissionCheckbox
              key={childKey}
              permission={{ ...perm, isPerEntity: true }}
              entityId={entityId}
              checked={effectiveChecked}
              onChange={() => onCheckboxToggle(perm, true, entityId)}
              disabled={disabled || isParentChecked}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default PerEntityPermissionList;
